






































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import VForm from '@/components/VForm.vue';
import FormInputField from '@/components/FormInputField.vue';
import { TrailerType, LoadType } from '@/interfaces/AxleLoadData';
import { debounce } from '@/utils/debounce';
import { nonNull } from '@/utils/nullable';
import RangeImageSlider from '@/components/RangeImageSlider.vue';
import {isMobile} from '@/utils/isMobile';
import Dropdown from '@/components/Dropdown.vue';


@Component({
  components: {RangeImageSlider, FormInputField, VForm, Dropdown},
})

export default class AxleLoadProgram extends Vue {
  @Prop({}) private labelTitle?: string;
  @Prop({}) private labelEnterValues?: string;
  @Prop({}) private labelTon?: string;
  @Prop({}) private labelMm?: string;
  @Prop({}) private labelKingpinLoad?: string;
  @Prop({}) private labelAxelLoad?: string;
  @Prop({}) private labelPlusWeightKingpin?: string;
  @Prop({}) private labelPlusWeightLoad?: string;
  @Prop({}) private labelWarningMaxKingpin?: string;
  @Prop({}) private labelWarningMaxAxleLoad?: string;
  @Prop({}) private labelTotalWheelbase?: string;
  @Prop({}) private labelCargoCenterGravity?: string;
  @Prop({}) private labelCargoCenterGravityFromKingpin?: string;
  @Prop({}) private labelTruckInformation?: string;
  @Prop({}) private labelLicencePlate?: string;
  @Prop({}) private labelTruckType?: string;
  @Prop({}) private labelMaxCarryWeight?: string;
  @Prop({}) private labelTrailerInformation?: string;
  @Prop({}) private labelTrailerType?: string;
  @Prop({}) private labelKingpinWeight?: string;
  @Prop({}) private labelAxleWeight?: string;
  @Prop({}) private labelWheelbaseLength?: string;
  @Prop({}) private labelWheelbaseExtension?: string;
  @Prop({}) private labelFifthWheel?: string;
  @Prop({}) private labelBogie?: string;
  @Prop({}) private labelLoadInformation?: string;
  @Prop({}) private labelLoadType?: string;
  @Prop({}) private labelLoadWeight?: string;
  @Prop({}) private labelConfirmReset?: string;
  @Prop({}) private labelTrailerLowLoader?: string;
  @Prop({}) private labelTrailerSemiLowLoader?: string;
  @Prop({}) private labelTrailerPlatformTrailer?: string;
  @Prop({}) private labelLoadShovel?: string;
  @Prop({}) private labelLoadContainer?: string;
  @Prop({}) private labelLoadTrack?: string;
  @Prop({}) private labelLoadJohnDeere?: string;
  @Prop({}) private labelReset?: string;
  @Prop({}) private disclaimerTitle?: string;
  @Prop({}) private disclaimerText?: string;

  // MaxKingpinLoad === bogie
  // Max Axleload === fifthwheel

  private isMobile = isMobile;
  private trailers = [
    {
      id: 'A_0-4ABD-PL_1_530',
      trailerName: this.labelTrailerLowLoader || '',
      image: 'A_0-4ABD-PL_1_530.png',
      length: 17.08,
      load: {
        startPositionInPercents: 0.3,
        endPositionInPercents: 0.35,
      },
      axle: {
        front: 1.75,
        rear: 14.2,
      },
    },
    {
      id: 'A_4ABSD-48_1',
      trailerName: this.labelTrailerSemiLowLoader || '',
      image: 'A_4ABSD-48_1.png',
      length: 13.35,
      load: {
        startPositionInPercents: 0.35,
        endPositionInPercents: 0.16,
      },
      axle: {
        front: 1.9,
        rear: 9.55,
      },
    },
    {
      id: 'A_4AOU-58_3',
      trailerName: this.labelTrailerPlatformTrailer || '',
      image: 'A_4AOU-58_3.png',
      length: 13.5,
      load: {
        startPositionInPercents: 0.175,
        endPositionInPercents: 0.145,
      },
      axle: {
        front: 2.3,
        rear: 9.76,
      },
    },
  ];
  private loads = [
    {
      id: 'Container',
      name: this.labelLoadContainer || '',
      size: {
        height: 2.4,
        width: 5,
      },
    },
    {
      id: 'Track',
      name: this.labelLoadTrack || '',
      size: {
        height: 1,
        width: 5.6,
      },
    },
    {
      id: 'Shovel',
      name: this.labelLoadShovel || '',
      size: {
        height: 2.3,
        width: 4.3,
      },
    },
    {
      id: 'John_deere',
      name: this.labelLoadJohnDeere || '',
      size: {
        height: 2.9,
        width: 4.1,
      },
    },
  ];
  private FORMAT_FIXED_LENGTH = 1;
  private LICENCE_PLATE = 'licence_plate';
  private TRUCK_TYPE = 'truck_type';
  private CARRY_WEIGHT = 'carry_weight';
  private TRAILER_TYPE = 'trailer_type';
  private LOAD_TYPE = 'load_type';
  private KINGPIN_WEIGHT = 'kingpin_weight';
  private AXLE_WEIGHT = 'axle_weight';
  private WHEELBASE_LENGTH = 'wheelbase_length';
  private WHEELBASE_EXTENSION = 'wheelbase_extension';
  private FIFTHWHEEL = 'fifthwheel';
  private BOGIE = 'bogie';
  private LOAD_WEIGHT = 'load_weight';
  private CARGO_CENTER = 'cargo_center';

  private licence: string | null = null;
  private truckType: string | null = null;
  private carryWeight: number | null = null;
  private kingpinWeight: number | null = null;
  private axleWeight: number | null = null;
  private wheelbaseLength: number | null = null;
  private wheelbaseExtension: number = 0;
  private loadWeight: number | null = null;
  private cargoCenter: number = 0;
  private kingpinLoad: number = 0;
  private axleLoad: number = 0;
  private fifthWheel: number = 0;
  private bogie: number = 0;
  private resetDropdownsTrigger: boolean = false;

  private defaultItemSize = 100;
  private loadImageWidth = this.defaultItemSize;
  private loadImageHeight = this.defaultItemSize;

  private selectedTrailerType: TrailerType = this.trailers[0];
  private selectedLoadType: LoadType = this.loads[0];

  private selectedLoadTypeValue: string = '';
  private selectedTrailerTypeValue: string = '';

  private MAX_CARGO_GRAVITY = 10000;
  private resetEnabled: boolean = false;

  private set selectedTrailerTypeId(value) {
    console.log('selected trailer type', value);
  }

  private get selectedTrailerTypeId() {
    return this.selectedTrailerType.id;
  }

  private set selectedLoadTypeId(value) {
    console.log('selected load type', value);
  }

  private get selectedLoadTypeId() {
    return this.selectedLoadType.id;
  }

  private resetForm() {
    const v = confirm(this.labelConfirmReset);

    if (v) {
      this.licence = '';
      this.truckType = '';
      this.carryWeight = null;
      this.selectedTrailerType = this.trailers[0];
      this.kingpinWeight = null;
      this.axleWeight = null;
      this.wheelbaseLength = null;
      this.wheelbaseExtension = 0;
      this.fifthWheel = 0;
      this.bogie = 0;
      this.wheelbaseExtension = 0;
      this.selectedLoadType = this.loads[0];
      this.loadWeight = null;
      this.cargoCenter = 0;
      this.kingpinLoad = 0;
      this.axleLoad = 0;
      this.resetEnabled = false;

      this.resetDropdowns();
      this.updateSliderPosition();
      this.updateLoadImageSize();
      this.updateUrl();
      this.updateCookie();
      this.updateAxleOverlay();
      (this.$refs.imageSlider as RangeImageSlider).clear();
    }
  }

  private formatLoadValue(value: number) {
    return value.toFixed(this.FORMAT_FIXED_LENGTH);
  }

  private recalculate() {
    debounce(() => {
      this.updateCookie();
      this.updateUrl();
      if (this.isDataFilled()) {
        this.kingpinLoad = this.calculateKingpinLoad();
        this.axleLoad = this.calculateAxleWeight();
      }
    }, 500, false)();
  }

  private getSlider(): HTMLInputElement {
    return this.$refs.slider as HTMLInputElement;
  }

  private getItem(): HTMLElement {
    return this.$refs.item as HTMLElement;
  }

  private getAxleLoadPicture(): HTMLElement {
    return this.$refs.axleLoadPicture as HTMLElement;
  }

  private mounted() {
    if (!isMobile) {
      if (this.isFilledUrl()) {
        this.updatePropertiesFromUrl();
      } else {
        this.updatePropertiesFromCookie();
      }
      this.updateSliderPosition();
      this.updateLoadImageSize();
      this.updateAxleOverlay();
      this.recalculate();
    }
  }

  private created() {
    window.addEventListener('resize', this.resizeEventListener);
  }

  private destroy() {
    window.removeEventListener('resize', this.resizeEventListener);
  }

  private resetDropdowns() {
    this.resetDropdownsTrigger = !this.resetDropdownsTrigger;
  }

  private onSliderPositionChanged(value: number) {
    const newVal = value;
    const layer2 = this.$refs.layer2 as HTMLElement;
    const slider = this.$refs.slider as HTMLInputElement;
    if (slider) {
      // ------- TOP OVERLAY -------
      const sliderRect = slider.getBoundingClientRect();
      const trailer = this.$refs.axleLoadPicture as HTMLElement;
      const trailerRect = trailer.getBoundingClientRect();
      const diffFrontAxleAndLoad = Math.abs(trailerRect.left - sliderRect.left)
          - (trailerRect.width * this.selectedTrailerType.axle.front / this.selectedTrailerType.length);
      layer2.style.marginLeft = (trailerRect.width * this.selectedTrailerType.axle.front
          / this.selectedTrailerType.length) + 'px';
      layer2.style.width = ((sliderRect.width / 100 * newVal) + diffFrontAxleAndLoad) + 'px';

      // ------- CARGO GRAVITY -------
      this.updateCurrentCargoGravity(newVal);

      this.recalculate();
    }
  }

  private isFilledUrl() {
    /**
     * By default the following inputs are filled:
     * - TRAILER_TYPE
     * - LOAD_TYPE
     * - WHEELBASE_EXTENSION
     * - CARGO_CENTER
     */
    const filledInputsByDefault = 4;

    return Array.from(new URL(window.location.href).searchParams.entries()).length > filledInputsByDefault;
  }

  private resizeEventListener(e: any) {
    this.updateSliderPosition();
    this.updateLoadImageSize();
  }

  private onLicenceChanged(value: string) {
    this.updateUrl();
    this.updateCookie();
  }

  private onTrackTypeChanged(value: string) {
    this.updateUrl();
    this.updateCookie();
  }

  private onTrailerTypeChanged(trailerTypeId: string) {
    this.selectedTrailerType = this.trailers.find((item) => item.id === trailerTypeId) as TrailerType;
    this.selectedTrailerTypeValue = this.selectedTrailerType.id;

    this.updateSliderPosition();
    this.updateLoadImageSize();
    this.updateUrl();
    this.updateCookie(30);
    this.updateAxleOverlay();

    (this.$refs.imageSlider as RangeImageSlider).clear();
  }

  private onLoadTypeChanged(loadTypeId: string) {
    this.selectedLoadType = this.loads.find((item) => item.id === loadTypeId) as LoadType;
    this.selectedLoadTypeValue = this.selectedLoadType.id;

    this.updateLoadImageSize();
    this.updateSliderPosition();
    this.updateUrl();
    this.updateCookie();
  }

  private onCargoCenterChanged(value: number) {
    debounce(() => {
      (this.$refs.imageSlider as RangeImageSlider).setValue(value / this.MAX_CARGO_GRAVITY * 100);
    }, 50, false)();
  }

  private updateAxleOverlay() {
    const trailer = this.$refs.axleLoadPicture as HTMLElement;
    const trailerRect = trailer.getBoundingClientRect();
    const axleOverlay = this.$refs.layer1 as HTMLElement;

    axleOverlay.style.marginLeft = (trailerRect.width * this.selectedTrailerType.axle.front
        / this.selectedTrailerType.length) + 'px';
    axleOverlay.style.marginRight = (trailerRect.width * this.selectedTrailerType.axle.rear
        / this.selectedTrailerType.length) + 'px';
    axleOverlay.style.width = (trailerRect.width * (this.selectedTrailerType.axle.rear
        - this.selectedTrailerType.axle.front) / this.selectedTrailerType.length) + 'px';
  }

  private updateCurrentCargoGravity(value: number) {
    this.cargoCenter = Math.round(this.MAX_CARGO_GRAVITY / 100 * value);
  }

  // -----------------
  // Slider
  // -----------------
  private updateLoadImageSize() {
    this.loadImageHeight = this.calculateLoadSize(this.selectedTrailerType.length, this.selectedLoadType.size.height);
    this.loadImageWidth = this.calculateLoadSize(this.selectedTrailerType.length, this.selectedLoadType.size.width);
  }

  private calculateLoadSize(trailerSize: number, loadSize: number) {
    const trailerRect = this.getAxleLoadPicture().getBoundingClientRect();
    return trailerRect.width / trailerSize * loadSize;
  }

  private updateSliderPosition() {
    this.resetEnabled = true;
    const trailerLoad = this.selectedTrailerType.load;
    const trailerRect = this.getAxleLoadPicture().getBoundingClientRect();
    const loadWidth = this.calculateLoadSize(this.selectedTrailerType.length, this.selectedLoadType.size.width);
    const halfOfLoadWidth = loadWidth / 2;

    this.getSlider().style.marginLeft = this.calculateSliderMarginLeft() + halfOfLoadWidth + 'px';
    this.getSlider().style.marginRight = (trailerRect.width * trailerLoad.endPositionInPercents) + halfOfLoadWidth + 'px';
    this.getSlider().style.width = (trailerRect.width *
        (1 - (trailerLoad.startPositionInPercents + trailerLoad.endPositionInPercents)) - loadWidth) + 'px';
  }

  private calculateSliderMarginLeft() {
    const trailerRect = this.getAxleLoadPicture().getBoundingClientRect();
    return (trailerRect.width * this.selectedTrailerType.load.startPositionInPercents);
  }

  // -------------------------------------
  // Update Cookie and Restore data from Cookie
  // -------------------------------------
  private updateCookie(days: number = 30): void {
    const checkAndUpdateCookie = (key: string, value: string | null | undefined) => {
      let date: Date;
      if (value == null || value === '') {
        date = new Date('01/01/1970');
      } else {
        date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      }
      const expires = `;expires=${date.toUTCString()}`;
      const path = 'path=/';

      document.cookie = `${key}=${value};${expires};${path}`;
    };

    checkAndUpdateCookie(this.LICENCE_PLATE, this.licence);
    checkAndUpdateCookie(this.TRUCK_TYPE, this.truckType);
    checkAndUpdateCookie(this.CARRY_WEIGHT, this.carryWeight?.toString());
    checkAndUpdateCookie(this.TRAILER_TYPE, this.selectedTrailerType.id);
    checkAndUpdateCookie(this.KINGPIN_WEIGHT, this.kingpinWeight?.toString());
    checkAndUpdateCookie(this.AXLE_WEIGHT, this.axleWeight?.toString());
    checkAndUpdateCookie(this.WHEELBASE_LENGTH, this.wheelbaseLength?.toString());
    checkAndUpdateCookie(this.WHEELBASE_EXTENSION, this.wheelbaseExtension?.toString());
    checkAndUpdateCookie(this.FIFTHWHEEL, this.fifthWheel?.toString());
    checkAndUpdateCookie(this.BOGIE, this.bogie?.toString());
    checkAndUpdateCookie(this.LOAD_TYPE, this.selectedLoadType.id);
    checkAndUpdateCookie(this.LOAD_WEIGHT, this.loadWeight?.toString());
    checkAndUpdateCookie(this.CARGO_CENTER, this.cargoCenter?.toString());
  }


  private processInputs(
      licencePlate: string,
      truckType: string,
      carryWeight: string,
      selectedTrailerTypeId: string,
      kingpinWeight: string,
      axleWeight: string,
      wheelbaseLength: string,
      wheelbaseExtension: string,
      fifthWheel: string,
      bogie: string,
      selectedLoadTypeId: string,
      loadWeight: string,
      cargoCenter: string) {
    if (licencePlate) { this.licence = licencePlate; }
    if (truckType) { this.truckType = truckType; }
    if (carryWeight) { this.carryWeight = Number(carryWeight); }

    if (selectedTrailerTypeId) {
      this.selectedTrailerType = this.trailers.find((item) => item.id === selectedTrailerTypeId) as TrailerType;
      this.selectedTrailerTypeValue = this.selectedTrailerType.id;
    } else {
      this.selectedTrailerType = this.trailers[0];
      this.selectedTrailerTypeValue = this.selectedTrailerType.id;
    }

    if (kingpinWeight) { this.kingpinWeight = Number(kingpinWeight); }
    if (axleWeight) { this.axleWeight = Number(axleWeight); }
    if (wheelbaseLength) { this.wheelbaseLength = Number(wheelbaseLength); }
    if (wheelbaseExtension) { this.wheelbaseExtension = Number(wheelbaseExtension); }
    if (fifthWheel) { this.fifthWheel = Number(fifthWheel); }
    if (bogie) { this.bogie = Number(bogie); }
    if (selectedLoadTypeId) {
      this.selectedLoadType = this.loads.find((item) => item.id === selectedLoadTypeId) as LoadType;
      this.selectedLoadTypeValue = this.selectedLoadType.id;
    }
    if (loadWeight) { this.loadWeight = Number(loadWeight); }
    if (cargoCenter) { this.cargoCenter = Number(cargoCenter); }
  }

  private updatePropertiesFromCookie() {
    const licencePlate = this.getCookieValue(this.LICENCE_PLATE);
    const truckType = this.getCookieValue(this.TRUCK_TYPE);
    const carryWeight = this.getCookieValue(this.CARRY_WEIGHT);
    const selectedTrailerTypeId = this.getCookieValue(this.TRAILER_TYPE);
    const kingpinWeight = this.getCookieValue(this.KINGPIN_WEIGHT);
    const axleWeight = this.getCookieValue(this.AXLE_WEIGHT);
    const wheelbaseLength = this.getCookieValue(this.WHEELBASE_LENGTH);
    const wheelbaseExtension = this.getCookieValue(this.WHEELBASE_EXTENSION);
    const fifthWheel = this.getCookieValue(this.FIFTHWHEEL);
    const bogie = this.getCookieValue(this.BOGIE);
    const selectedLoadTypeId = this.getCookieValue(this.LOAD_TYPE);
    const loadWeight = this.getCookieValue(this.LOAD_WEIGHT);
    const cargoCenter = this.getCookieValue(this.CARGO_CENTER);

    this.processInputs(
        licencePlate!,
        truckType!,
        carryWeight!,
        selectedTrailerTypeId!,
        kingpinWeight!,
        axleWeight!,
        wheelbaseLength!,
        wheelbaseExtension!,
        fifthWheel!,
        bogie!,
        selectedLoadTypeId!,
        loadWeight!,
        cargoCenter!);
  }

  private getCookieValue(name: string) {
    if (document.cookie.length > 0) {
      let start = document.cookie.indexOf(name + '=');
      if (start !== -1) {
        start = start + name.length + 1;
        let end = document.cookie.indexOf(';', start);
        if (end === -1) {
          end = document.cookie.length;
        }
        return unescape(document.cookie.substring(start, end));
      }
    }
    return '';
  }

  // -------------------------------------
  // Update URL and Restore data from URL
  // -------------------------------------
  private updateUrl() {
    const url = new URL(window.location.href);
    const checkAndUpdateUrl = (key: string, value: string | null | undefined) => {
      if (value == null || value === '') {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, value);
      }
    };

    checkAndUpdateUrl(this.LICENCE_PLATE, this.licence);
    checkAndUpdateUrl(this.TRUCK_TYPE, this.truckType);
    checkAndUpdateUrl(this.CARRY_WEIGHT, this.carryWeight?.toString());
    checkAndUpdateUrl(this.TRAILER_TYPE, this.selectedTrailerType.id);
    checkAndUpdateUrl(this.KINGPIN_WEIGHT, this.kingpinWeight?.toString());
    checkAndUpdateUrl(this.AXLE_WEIGHT, this.axleWeight?.toString());
    checkAndUpdateUrl(this.WHEELBASE_LENGTH, this.wheelbaseLength?.toString());
    checkAndUpdateUrl(this.WHEELBASE_EXTENSION, this.wheelbaseExtension?.toString());
    checkAndUpdateUrl(this.FIFTHWHEEL, this.fifthWheel?.toString());
    checkAndUpdateUrl(this.BOGIE, this.bogie?.toString());
    checkAndUpdateUrl(this.LOAD_TYPE, this.selectedLoadType.id);
    checkAndUpdateUrl(this.LOAD_WEIGHT, this.loadWeight?.toString());
    checkAndUpdateUrl(this.CARGO_CENTER, this.cargoCenter?.toString());

    window.history.replaceState(null, document.title, url.toString());
  }

  private updatePropertiesFromUrl() {
    const url = new URL(window.location.href);
    const licencePlate = url.searchParams.get(this.LICENCE_PLATE);
    const truckType = url.searchParams.get(this.TRUCK_TYPE);
    const carryWeight = url.searchParams.get(this.CARRY_WEIGHT);
    const selectedTrailerTypeId = url.searchParams.get(this.TRAILER_TYPE);
    const kingpinWeight = url.searchParams.get(this.KINGPIN_WEIGHT);
    const axleWeight = url.searchParams.get(this.AXLE_WEIGHT);
    const wheelbaseLength = url.searchParams.get(this.WHEELBASE_LENGTH);
    const wheelbaseExtension = url.searchParams.get(this.WHEELBASE_EXTENSION);
    const fifthWheel = url.searchParams.get(this.FIFTHWHEEL);
    const bogie = url.searchParams.get(this.BOGIE);
    const selectedLoadTypeId = url.searchParams.get(this.LOAD_TYPE);
    const loadWeight = url.searchParams.get(this.LOAD_WEIGHT);
    const cargoCenter = url.searchParams.get(this.CARGO_CENTER);

    this.processInputs(
        licencePlate!,
        truckType!,
        carryWeight!,
        selectedTrailerTypeId!,
        kingpinWeight!,
        axleWeight!,
        wheelbaseLength!,
        wheelbaseExtension!,
        fifthWheel!,
        bogie!,
        selectedLoadTypeId!,
        loadWeight!,
        cargoCenter!);
  }

  // ---------------------
  // Axle Load calculation
  // ---------------------
  private isDataFilled() {
    return this.loadWeight &&
        this.wheelbaseLength && this.wheelbaseLength > 0 &&
        this.axleWeight &&
        this.kingpinWeight;
  }

  private calculateClutchPressure() {
    return (nonNull(this.cargoCenter) * nonNull(this.loadWeight))
        / (nonNull(this.wheelbaseLength) + nonNull(this.wheelbaseExtension));
  }

  private calculateAxleWeight() {
    return this.calculateClutchPressure() + nonNull(this.axleWeight);
  }

  private calculateLoadingPressure() {
    return nonNull(this.loadWeight) - this.calculateClutchPressure();
  }

  private calculateKingpinLoad() {
    return nonNull(this.loadWeight) + nonNull(this.kingpinWeight) + nonNull(this.axleWeight)
        - this.calculateAxleWeight();
  }
}
